import { render } from "./OverviewComments.vue?vue&type=template&id=1937c601&scoped=true"
import script from "./OverviewComments.vue?vue&type=script&lang=js"
export * from "./OverviewComments.vue?vue&type=script&lang=js"

import "./OverviewComments.vue?vue&type=style&index=0&id=1937c601&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1937c601"],['__file',"src/scripts/view/review/components/receiver/OverviewComments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1937c601"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1937c601', __exports__)) {
    api.reload('1937c601', __exports__)
  }
  
  module.hot.accept("./OverviewComments.vue?vue&type=template&id=1937c601&scoped=true", () => {
    api.rerender('1937c601', render)
  })

}


export default __exports__